$(document).ready(function(){
    // console.log(locationObj)
    // if (locationObj.postcode) {
    //     // console.log(locationObj.suburb)
    //     $('#postcode1').val(locationObj.suburb.replace(/\+/, " ")+', '+locationObj.state+', '+locationObj.postcode);
    //     $('#deliverytrigger1').trigger('click');
    // } 

    $('.delivery-pickup .nav-tabs a').click(function(ev){
        ev.preventDefault();
        const target = $(this).attr('href');
        $('.delivery-pickup .nav-tabs li').removeClass('active');
        $(this).parent().addClass('active');
        $('.delivery-pickup .tab-pane').removeClass('show active');
        $(target).addClass('show active');
    })
    $('.drawer-location-inner, .close-drawer-location').click(function(){
        if($(this).hasClass('get-suburb')){return false;}
        $('.sidebar-drawer-location').addClass('hidden');
        $('body').removeClass('overflow-hidden');
    });

    // Postage calculator #01 (typing...)
    $('input#postcode1').val();
    $('input#postcode1').keyup(function(e){  
        var txtInput = $(this).val();
        if (txtInput.length > 2){
            $.ajax({
                url: "https://1117015.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=713&deploy=1&compid=1117015&ns-at=AAEJ7tMQEHiNlvu41bPcPH-Klcl0BC-WPko6HsiOAER-WqJ5IqE&q="+txtInput,
                type: "get",
                crosscallDomain: true,
                dataType: "jsonp"
            }).done(function (data) {
                // console.log(data);
                $('ul.suburb-list').html('');
                if (data.localities == "") {
                    $('ul.suburb-list').append('<li><strong>Not Found</strong></li>')
                } else {
                    displaySuburb(data.localities.locality);
                }
            }).fail(function(jqXHR, textStatus, errorThrown) {
                console.log(textStatus + '; ' + errorThrown);
            })
        } else {
            $('#suburb').removeClass('active');
        }
    });

    function isObject (value) {
     return value && typeof value === 'object' && value.constructor === Object;
    }

    // Postage calculator #02 (display suburb)
    function displaySuburb(data) {
        if(isObject(data)){data = [data]}
        for (var i = 0; i < data.length; i++) {
            var attr = 'postcode="'+data[i].postcode+'" latitude="'+data[i].latitude+'" longitude="'+data[i].longitude+'" state="'+data[i].state+'"';
            $('ul.suburb-list').append('<li '+attr+'><strong>' + data[i].location + '</strong>, ' + data[i].state + ', ' + data[i].postcode + '</li>')
        }
    }

    // Postage calculator #03 (get suburb)
    $("ul.suburb-list").on('click', 'li', function(ev) {
        // console.log(locationObj);
        $('#postcode1').val($(this).text());
        var selectedLoc = $(this).text().split(',');
        var selectedSuburb = selectedLoc[0].replace(/ /gi, "+");
        $('ul.suburb-list').html('');

        $('#productId').attr('data-postcode', $(this).attr('postcode'));
        $('#productId').attr('data-suburb', selectedSuburb);

        //New format storing location data
        locationObj = {
            suburb: selectedSuburb,
            postcode: $(this).attr('postcode'),
            latitude: $(this).attr('latitude'),
            longitude: $(this).attr('longitude'),
            state: $(this).attr('state')
        }

        $('#productId script').text(JSON.stringify(locationObj))
        localStorage.setItem("locationData", JSON.stringify(locationObj));
        
        $('#deliverytrigger1').trigger('click');
    });
})
$('.change_suburb').click(function(ev){
    ev.preventDefault();
    if ($(this).hasClass('cart-page')) {
        $('.location_information').show();
        $('.check-result-container').hide();
    } else {
        $('.sidebar-drawer-location').removeClass('hidden');
        $('body').addClass('overflow-hidden');
    }
    $('#postcode1').val('').focus();
});

// Postage calculator #04 (click go)
$('#deliverytrigger1').click(function(ev) {
    ev.preventDefault();
    if (locationObj) {
        if ($('.this-is-cart-page').length != 0) {
            var sku = $('#allsku').attr('data-sku');
        } else {
            var sku = $('.sku').text();
        }
        postageCalc(sku);
        $('.close-drawer-location').click();
    }
});

// Postage calculator #05 (ajax call...)
function postageCalc(sku){
    if(!locationObj){return false;}
    // Loader here
    $('.spinner-1 .loading__spinner').removeClass('hidden');
    $('.delivery-pickup .spinner-1').show();
    var postcode = locationObj.postcode;
    var suburb = locationObj.suburb;
    var url = 'https://1117015.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=712&deploy=1&compid=1117015&ns-at=AAEJ7tMQmWDVLsk37sTXyeC7k2gKi91BwzdlLcYf8Y9arlMnQew&postcode='+postcode+'&suburb='+suburb+'&item_sku='+sku+'&source=yardtopia-au';
    $.ajax({
        url: url,
        type: "get",
        crosscallDomain: true,
        dataType: "jsonp",
        beforeSend: function(xhr) {}
    }).done(function(data) {
        // console.log("data",data);
        if (data.error.length >= 1) {
           $('.delivery-check-result').hide();
           $('.location-unknown').find(".location_information").show();
           $('.location-unknown').find(".location_set_info").hide();
           $('.check-result-container #noprice').remove();
           $('.check-result-container').append('<p id="noprice" style="font-size:13px;">This area requires a custom freight quotation. Please contact us via 1300 169 600 during business hours for assistance. </p>');
           $('.delivery-pickup .spinner-1').hide();
           $('.check-result-container').slideDown('slow');
           $(".moreless-button").show();
           console.log(data.error);
        } else {
            updatePrice(data.uniq_rates);
            var get_state = data.shipping_state;
            function getState() {
                getQuantityData(function(dataQuantity) {
                    // console.log(dataQuantity)
                    if (dataQuantity.length === 1) {
                      var d = dataQuantity[0].inventory;
                      var locationDivs = ''; // String to hold all location divs
                
                      for (var l = 0; l < d.length; l++) {
                        var locationId = '.location-' + d[l].inventory_location_id;
                        var getQuantity = d[l].location_quantity_available;
                        var getStateName = d[l].inventory_location_name;
                        var words = getStateName.split(/\s+/);
                        
                        // Get the last word
                        var lastWord = words.slice(-1).join(' ');
                        locationDivs += `<div class="location_quantity hidden" data-location-name="${lastWord}" data-location-quantity="${getQuantity}"></div>`;
                      }
                
                      // Append all location divs at once
                      $(".location_wise_inventory").html(locationDivs);
                    }
                });
            }
            getState();
        }
    }).fail(function() {
        $('.check-result-container').show().html('Unkown errors, please try again later!');
        $('.delivery-pickup .spinner-1').hide();
    });
}

function updatePrice(e) {
    // Update location display
    $('.location_set_info')
      .find(".info strong")
      .text(locationObj.suburb.replace(/\+/, ' ') + ', ' + locationObj.state + ' ' + locationObj.postcode);

    // Check delivery data availability
    if (void 0 === e == 0) {
      jQuery(window).trigger("resize").trigger("scroll");

      $(".premium_diverse-container").hide();
      $('.location-unknown').find(".location_set_info").show();
      $('.location-unknown').find(".location_information").hide();

      $(".delivery-check-result").show();
      $(".delivery-check-result .rate").html("Not Available");
      $(".delivery-check-result #regular").html("Please contact us for a quote");

      $(".default-hide.cart-page").hide();
      $("#noprice").hide();

      // Fetch delivery info JSON
      $.getJSON("https://lifespanonline.com.au/postage-query/info/delivery-information.json", function(t) {
        $(".delivery-info").each(function(e) {
            var i = $(this).attr("data-deliveryinfo");

            if (t[i]) {
                // console.log(i)
                $(".delivery-info." + i + " ul").html(t[i].includes.join(""));
                if (t[i].additional_info !== "") {
                    $(".delivery-info." + i + " ul").append(t[i].additional_info);
                }
            }
        });

        for (var i = 0; i < e.length; i++) {
          var a = e[i].type.replace(/\|/g, "_");

          $(".cart-page." + a).show();

          if (e[i].total_price == 0) {
            $(".delivery-check-result #" + a).html(t[a].if_zero);
          } else {
            var n = e[i].total_price.toFixed(2);
            $(".delivery-check-result #" + a).html("$" + n);
          }

          // Handle pickup logic
          if (e[i].type === "pickup") {
            var get_state = e[i].display_code;
            // console.log("get_state", e[i]);
            if(e[i].total_price <= 0){
                $('.pickup-container').hide();
            } else {
                $(".pickup-title").text(get_state);
                $(".pickup-price").text(e[i].total_price);
                $('.pickup-container').show();
            }
          }

          // Show premium diverse container
          if (e[i].type === "premium|diverse") {
            $(".premium_diverse-container").show();
          }
        }
      });
    } else {
      // Fallback if delivery data not available
      $('.location-unknown').find(".location_set_info").hide();
      $('.location-unknown').find(".location_information").show();
      $(".delivery-check-result").hide();

      $(".check-result-container").append(
        '<p id="noprice" style="font-size:13px;">Please contact us via online chat or phone for a tailored shipping quote. </p>'
      );
    }

    // UI cleanup and triggers
    $(".delivery-pickup .spinner-1").hide();
    $(".clearfix").find(".pull-right").trigger('click');
    $(".check-result-container").slideDown("slow");
}
$('#availability-trigger').on('click', function(e) {
    if (!$(this).hasClass('fetched')) {
        pickUpLocation();
        $(this).addClass('fetched')
    }
});
// Stock Availability in each store #02 (Quantity)
function getQuantityData(logResults){
    var isMulti = $('.sku').attr('data-multisku');
    if (isMulti == 'false') {
       var sku = $('.sku').text();
    } else {
       var sku = $('.sku').attr('data-skus');
    }
    var data;
    $.ajax({
        url: "https://1117015.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=623&deploy=1&compid=1117015&ns-at=AAEJ7tMQkyX-9quosAYuoRdLWndgI5fkODhy5BL-FR50CUontp0&item_key_type=sku&item_keys="+sku+"&location=15,10,9&jsonp=y",
        type: "get",
        crosscallDomain: true,
        dataType: "jsonp",
        jsonpCallback: "logResults",
        success: function (resp) {
            //console.log("resp",resp);
            data = resp;
            logResults(data.inventory);
            $('.delivery-pickup .spinner-1').hide();
        }, 
        error: function () {}
    });
}
// Stock Availability in each store #03 (Display)
function pickUpLocation(){
    var i;
    $('.delivery-pickup .spinner-1').show();
    getQuantityData(function(dataQuantity) {
        if (dataQuantity.length == 1) {
            var d = dataQuantity[0].inventory;
            for (var l = 0; l < d.length; l++) {
                var locationId = '.location-'+d[l].inventory_location_id;
                if (d[l].location_quantity_available < 10 ) {
                    if (d[l].location_quantity_available < 1 ) {
                       $("#dynamicPickUpResult "+locationId).addClass('out-stock');
                       $("#dynamicPickUpResult "+locationId).html('<span class="radar"><span class="circle"></span></span>Out of Stock');
                    } else {
                        $("#dynamicPickUpResult "+locationId).removeClass('out-stock').addClass('low-stock');
                        $("#dynamicPickUpResult "+locationId).html('<span class="radar"><span class="circle"></span></span>Limited Stock');
                    }
                } else {
                    $("#dynamicPickUpResult "+locationId).removeClass('out-stock').addClass('in-stock');
                    $("#dynamicPickUpResult "+locationId).html('<span class="radar"><span class="circle"></span></span>In Stock');
                }
            }
        }

        // Multiproduct or variant
        if (dataQuantity.length > 1) {
         for (var k = 0; k < dataQuantity.length; k++) {
           var sku = dataQuantity[k].sku.replace('.', '-');
           for (var m =  0; m < dataQuantity[k].inventory.length; m++) {
             // Minimise loading time we only process the exact location id
             var locId = dataQuantity[k].inventory[m].inventory_location_id;
             if (locId == '15' || locId == '10' || locId == '9') {
               var invQuant = dataQuantity[k].inventory[m].location_quantity_available;
               var locationId = '.location-'+locId+'.'+sku;
               if (invQuant < 10 ) {
                 if (invQuant < 1 ) {
                   $("#dynamicPickUpResult "+locationId).addClass('notavailable');
                   $("#dynamicPickUpResult "+locationId).text('Out of Stock');
                 } else {
                   $("#dynamicPickUpResult "+locationId).text('Limited Stock');
                   $("#dynamicPickUpResult "+locationId).addClass('limited-stock');
                 }
               }else{
                 $("#dynamicPickUpResult "+locationId).addClass('available');
                 $("#dynamicPickUpResult "+locationId).text('In Stock');
               }
             }
           }
         }
        }
    });
}